<template>
    <div class="container-xxl login-page-root">
        <div class="authentication-wrapper authentication-basic container-p-y">
            <div class="authentication-inner py-6">
                <div class="card shadow-lg border-0 login-card">
                    <div class="card-body p-6 p-sm-8 p-lg-10">
                        <div class="app-brand justify-content-center mb-4">
                            <img :src="logoPath" style="width: 60% !important" alt="شعار المنصة" />
                        </div>
                        <h4 class="text-center mb-1 fw-semibold">{{ WebSiteName }}</h4>
                        <div class="divider my-5">
                            <div class="divider-text text-body-secondary small">حالة المرفق</div>
                        </div>
                        <p class="text-center text-body mb-6 px-2" style="line-height: 1.75">
                            {{ bodyMessage }}
                        </p>
                        <div class="d-grid gap-2">
                            <button type="button" class="btn btn-primary" @click.prevent="refreshSession">
                                تحديث الحالة
                            </button>
                            <button type="button" class="btn btn-label-secondary" @click.prevent="logout">
                                تسجيل الخروج
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import HelperMixin from '../../Shared/HelperMixin.vue';

export default {
    name: 'FacilityOnboardingHold',
    mixins: [HelperMixin],
    computed: {
        bodyMessage() {
            if (this.$route.name === 'FacilityOnboardingMinistry') {
                return 'حساب المرفق في انتظار الموافقة من قبل الوزارة لتأكيد الحساب. لا يمكن استخدام بقية الخدمات حتى اكتمال الاعتماد.';
            }
            return 'تم تحويل بيانات الجرد والكميات المبدئية إلى الإدارة لمراجعة البيانات. سيتم إشعاركم عند اكتمال المراجعة الصيدلانية، ثم تنتظرون الاعتماد الوزاري النهائي.';
        }
    },
    async created() {
        this.$blockUI.$loading = this.$loading;
        await this.CheckLoginStatus();
        if (!this.loginDetails) {
            window.location.href = '/Login';
        }
    },
    methods: {
        async refreshSession() {
            this.$blockUI.Start();
            try {
                const res = await this.$http.GetFacilityOnboardingStatus();
                const raw =
                    res.data &&
                    (res.data.facilityOnboardingStatus ?? res.data.FacilityOnboardingStatus);
                const st = raw != null && raw !== '' ? Number(raw) : null;
                if (this.loginDetails && st != null && !Number.isNaN(st)) {
                    this.$set(this.loginDetails, 'facilityOnboardingStatus', st);
                    try {
                        localStorage.setItem(
                            'currentUser-client',
                            this.encrypt(JSON.stringify(this.loginDetails), this.PlatFormPass)
                        );
                    } catch (e) {
                        /* ignore */
                    }
                }
                if (st === 0 || st === null || Number.isNaN(st)) {
                    window.location.href = '/Home';
                    return;
                }
                if (st === 1) {
                    window.location.href = '/InventoryCounts';
                    return;
                }
                if (st === 2) {
                    window.location.href = '/FacilityOnboarding/AwaitingPharmacyReview';
                    return;
                }
                if (st === 3) {
                    window.location.href = '/FacilityOnboarding/AwaitingMinistryApproval';
                    return;
                }
                window.location.reload();
            } catch (e) {
                const msg =
                    e && e.response && e.response.data
                        ? e.response.data
                        : 'تعذر تحديث الحالة. أعد المحاولة أو سجّل الخروج ثم الدخول.';
                this.$helper.ShowMessage('error', 'خطأ', msg);
            } finally {
                this.$blockUI.Stop();
            }
        }
    }
};
</script>

<style scoped>
.login-page-root .authentication-inner {
    min-height: 72vh;
    display: flex;
    align-items: center;
    justify-content: center;
}
.login-card {
    border-radius: 0.75rem;
    width: 100%;
    max-width: min(92vw, 42rem);
    margin-inline: auto;
}
</style>
